import React from "react";
import { MdLocationOn, MdSchool, MdCalendarToday } from "react-icons/md";
import awsp from "../assets/AWSP.png";
import awsdevop from "../assets/AWDevOp.png";
import awsecurity from "../assets/AWSecurity.png";
import kubernetes from "../assets/kubernetes.png";

const Education = () => {
  const education = {
    id: 1,
    university: "The Ohio State University",
    degree: "B.S. In Computer Science and Engineering",
    location: "Columbus, OH",
    period: "2014 - 2019",
    coursework: [
      "Object Oriented Programming",
      "Databases",
      "Discrete Maths",
      "Advance Data Structures and Algorithms",
      "Operating Systems",
      "Computer Networks",
      "Machine Learning",
      "Data Mining",
      "Information Retrieval",
      "Image Processing",
    ],
  };

  const certifications = [
    {
      id: 1,
      src: awsp,
      url: "https://www.credly.com/badges/8e402085-b4fc-4770-8df1-adcf09656d9c/public_url",
      title: "AWS Certified Solutions Architect",
    },
    {
      id: 2,
      src: awsdevop,
      url: "https://www.credly.com/badges/b8f3935c-9674-4867-99ae-8cad22f05e73/public_url",
      title: "AWS Certified DevOps Engineer",
    },
    {
      id: 3,
      src: awsecurity,
      url: "https://www.credly.com/badges/8eff8532-3eca-4789-878f-188f7cbf1da2/public_url",
      title: "AWS Certified Security",
    },
    {
      id: 4,
      src: kubernetes,
      url: "https://www.credly.com/badges/e134abec-8a17-4b5a-a07b-c8e89e27a31e/public_url",
      title: "Kubernetes Administrator",
    },
  ];

  return (
    <div
      name="education"
      className="w-full bg-gradient-to-b from-gray-950 via-zinc-900 to-slate-950 text-white py-6 md:py-8 lg:py-10"
    >
      <div className="max-w-screen-lg mx-auto px-6 md:px-8">
        {/* Section Header */}
        <div className="flex items-center gap-3 mb-6">
          <div className="h-1 w-12 bg-blue-500"></div>
          <h3 className="text-2xl md:text-3xl lg:text-4xl font-extrabold tracking-tight">
            Education
          </h3>
        </div>

        {/* Degree Card */}
        <div className="bg-gray-900/40 border border-gray-700/40 rounded-lg backdrop-blur-sm p-5 md:p-6 mb-4 hover:border-blue-500/50 hover:shadow-lg hover:shadow-blue-500/10 transition-all duration-300">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6">
            {/* Icon */}
            <div className="flex-shrink-0 w-14 h-14 md:w-16 md:h-16 bg-gradient-to-br from-blue-600 to-cyan-600 rounded-xl flex items-center justify-center shadow-lg shadow-blue-500/20">
              <MdSchool className="text-white text-2xl md:text-3xl" />
            </div>

            {/* Info */}
            <div className="flex-1">
              <h4 className="text-lg md:text-xl font-bold text-white mb-2 tracking-tight">
                {education.degree}
              </h4>
              <div className="flex flex-wrap items-center gap-3">
                <div className="flex items-center gap-1.5">
                  <MdSchool className="text-blue-400" size={16} />
                  <span className="text-sm font-medium text-gray-200">{education.university}</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <MdLocationOn className="text-cyan-400" size={16} />
                  <span className="text-sm text-gray-300">{education.location}</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <MdCalendarToday className="text-blue-400" size={16} />
                  <span className="text-sm font-medium text-blue-300">{education.period}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Coursework */}
          <div className="mt-5 pt-5 border-t border-gray-700/40">
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">
              Relevant Coursework
            </p>
            <div className="flex flex-wrap gap-2">
              {education.coursework.map((course, idx) => (
                <span
                  key={idx}
                  className="px-2.5 py-1 text-[10px] xs:text-xs font-medium bg-gradient-to-r from-blue-600/20 to-cyan-600/20 border border-blue-500/30 rounded-md text-blue-300 hover:from-blue-600/30 hover:to-cyan-600/30 hover:border-blue-500/50 transition-all duration-300"
                >
                  {course}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Certifications */}
        <div className="bg-gray-900/40 border border-gray-700/40 rounded-lg backdrop-blur-sm p-5 md:p-6 hover:border-blue-500/50 hover:shadow-lg hover:shadow-blue-500/10 transition-all duration-300">
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-4">
            Certifications
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {certifications.map((c) => (
              <a
                key={c.id}
                href={c.url}
                target="_blank"
                rel="noreferrer"
                className="group rounded-lg border border-gray-700/40 bg-gray-950/40 hover:bg-gray-800/50 hover:border-blue-500/50 transition-all duration-300 p-3 flex flex-col items-center text-center"
                aria-label={`Open credential: ${c.title}`}
              >
                <img
                  src={c.src}
                  alt={c.title}
                  className="w-12 h-12 sm:w-14 sm:h-14 object-contain mb-2 group-hover:scale-110 transition-transform duration-300"
                />
                <p className="text-[10px] sm:text-xs text-gray-200 font-medium leading-snug">
                  {c.title}
                </p>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Education;
